import { useForm, usePage } from '@inertiajs/react'
import { FormEvent } from 'react'
import { Loader2 } from 'lucide-react'
import AuthLayout, {
  AuthCardHeading,
  AuthMessage,
  BackToSignIn,
} from '@/layouts/AuthLayout'
import { PageProps } from '@/types'

export default function ForgotPassword() {
  const { flash } = usePage<PageProps>().props
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/users/password')
  }

  const fieldErrors = errors as Record<string, string>
  const emailError = fieldErrors['email'] || fieldErrors['user.email']
  const formError = flash?.alert || flash?.error || null

  return (
    <AuthLayout title="Reset Password">
      <AuthCardHeading
        title="Reset your password"
        description="Enter the email address on your account and we'll send you a link to choose a new password."
      />

      {flash?.notice && <AuthMessage tone="success">{flash.notice}</AuthMessage>}
      {formError && <AuthMessage tone="error">{formError}</AuthMessage>}

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label htmlFor="email" className="auth-label">
            Email address
          </label>
          <input
            id="email"
            name="email"
            type="email"
            inputMode="email"
            autoComplete="email"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            required
            autoFocus
            value={data.user.email}
            onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
            className="auth-input"
            aria-invalid={Boolean(emailError)}
            aria-describedby={emailError ? 'email-error' : undefined}
          />
          {emailError && (
            <p id="email-error" className="mt-1.5 text-sm text-status-error">
              {emailError}
            </p>
          )}
        </div>

        <button type="submit" disabled={processing} className="auth-submit">
          {processing ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
              Sending&hellip;
            </>
          ) : (
            'Send reset instructions'
          )}
        </button>
      </form>

      <BackToSignIn />
    </AuthLayout>
  )
}
